import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useMemo, useState } from 'react';
import { format } from 'date-fns';
import { useForm } from 'react-hook-form';
import { filter as filterIcon } from '@ibk/shared-assets';
import { useTranslation } from '@ibk/shared-translation';
import { Chip } from '@ibk/shared-ui';
import { AccountTransactionsFilter } from '../../AccountTransactionsFilter';
import styles from '../AccountTransactions.module.css';
export const Filters = ({ onApplyFilters, defaultValues }) => {
    const { t } = useTranslation();
    const { watch, setValue } = useForm({ defaultValues });
    const { from, to, direction, type } = watch();
    const [isFilterDrawerOpen, setIsFilterDrawerOpen] = useState(false);
    const appliedFilters = useMemo(() => {
        return { from, to, type, direction };
    }, [from, to, type, direction]);
    useEffect(() => {
        onApplyFilters(appliedFilters);
    }, [appliedFilters, onApplyFilters]);
    const handleDirectionClick = (direction) => {
        if (watch('direction') === direction) {
            setValue('direction', undefined);
        }
        else {
            setValue('direction', direction);
        }
    };
    const shouldShowDateRangeFilter = useMemo(() => {
        return (!!from || !!to) && (from !== defaultValues.from || to !== defaultValues.to);
    }, [from, to, defaultValues]);
    const handleDateRangeChipClick = () => {
        setValue('from', defaultValues.from);
        setValue('to', defaultValues.to);
    };
    const handleCloseFilterDrawer = () => {
        setIsFilterDrawerOpen(false);
    };
    const handleClearFilters = () => {
        handleDateRangeChipClick();
        setValue('direction', undefined);
        handleCloseFilterDrawer();
    };
    const handleApplyFilters = (startAt, endAt, _type, direction) => {
        setValue('from', startAt);
        setValue('to', endAt);
        setValue('direction', direction);
        handleCloseFilterDrawer();
    };
    const hasActiveFilters = useMemo(() => {
        return [from !== defaultValues.from, to !== defaultValues.to, direction !== undefined].some(Boolean);
    }, [from, to, direction, defaultValues]);
    return (_jsxs("div", { className: styles.filters, "data-testid": 'containerAccountTransactionsFilters', children: [_jsx(Chip, { text: t('contabilidade-digital.account-transactions.filters.entries'), size: 'small', selected: direction === 'credit', onClick: () => handleDirectionClick('credit'), "data-testid": 'buttonAccountTransactionsFilterEntries' }), _jsx(Chip, { text: t('contabilidade-digital.account-transactions.filters.outgoings'), size: 'small', selected: direction === 'debit', onClick: () => handleDirectionClick('debit'), "data-testid": 'buttonAccountTransactionsFilterOutgoings' }), shouldShowDateRangeFilter && (_jsx(Chip, { text: t('contabilidade-digital.account-transactions.filters.date-range', {
                    from: from ? format(new Date(from), 'dd/MM/yyyy') : '',
                    to: to ? format(new Date(to), 'dd/MM/yyyy') : '',
                }), size: 'small', selected: true, onClick: handleDateRangeChipClick, "data-testid": 'buttonAccountTransactionsFilterDateRange' })), _jsx(Chip, { text: t('contabilidade-digital.account-transactions.filters.filter'), size: 'small', selected: false, leftImage: filterIcon, onClick: () => setIsFilterDrawerOpen(!isFilterDrawerOpen), "data-testid": 'buttonAccountTransactionsFilterAction' }), hasActiveFilters && (_jsx("button", { className: styles.clearFiltersButton, type: 'button', onClick: handleClearFilters, "data-testid": 'buttonAccountTransactionsClearFilters', children: t('contabilidade-digital.account-transactions.filter.clear-filters') })), isFilterDrawerOpen && (_jsx(AccountTransactionsFilter, { dataTestId: 'accountTransactionsFilter', initialFilters: { startAt: from, endAt: to, direction }, resetFilters: {}, onClose: handleCloseFilterDrawer, clearFilters: handleClearFilters, applyFilters: handleApplyFilters }))] }));
};
